import { Epoch, StudyEntityType } from '@faro/study-designer-model';
import { createStudyEntityHookFactory } from '../createStudyEntityHookFactory';
import { epochClient, EpochPathParameters } from './StudyEpochClient';

const factory = createStudyEntityHookFactory<Epoch, EpochPathParameters>(StudyEntityType.Epoch);

export const useEpochs = factory.list(epochClient.list);
export const useEpochInsert = factory.mutate(epochClient.create);
export const useEpochCreate = factory.mutate(epochClient.createWithCycle);
export const useEpochModify = factory.mutate(epochClient.modify);
export const useEpochDelete = factory.mutate(epochClient.delete);
